module.exports = __webpack_public_path__ + "img/menu_lines.a7682b2f.svg";